import React, { VoidFunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { LoginPageLayout } from 'record-it-components/pageLayout/LoginPageLayout/LoginPageLayout';
import { prepareProps } from 'record-it-components/utils/propUtils';

export const LoginLayout: VoidFunctionComponent = React.memo((props) => {
  prepareProps({ props, ignoreChildren: true });

  return (
    <LoginPageLayout>
      <Outlet></Outlet>
    </LoginPageLayout>
  );
});
